<script setup lang="ts">
const currentYear = new Date().getFullYear();
</script>

<template>
  <footer data-testid="app-footer" class="text-2xs text-muted text-center p-4">
    <p>
      &copy; 2019 &ndash; {{ currentYear }}
      <a
        href="https://sera.tech/"
        target="_blank"
        rel="noopener noreferrer"
        class="hover:underline hover:text-foreground"
        >Sera Systems, Inc.</a
      >
      All rights reserved.
      <span class="mx-1">&middot;</span>
      <a
        href="https://sera.tech/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        class="hover:underline hover:text-foreground"
        >Privacy Policy</a
      >
    </p>
  </footer>
</template>
